import { getFilename } from '../../utils/getFilename';
import styled from 'styled-components';
import { useKeycloakReady } from '../../hooks';
import { GetDocumentResponse, useGetDocument, useGetDocumentForCI } from 'all-in-one-shared-api';
import { message, Typography } from 'antd';
import { MessageType } from '../../models/MessageType';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const LinkText = styled(Text)`
  cursor: pointer;
  color: var(--home-news-promotion-link-color);
`;

export interface DocumentLinkProps {
  filePath: string;
  isSettlement?: boolean;
  documentType?: string;
}
export const DocumentLink = ({ filePath, isSettlement = false, documentType }: DocumentLinkProps) => {
  const { token } = useKeycloakReady();
  const { t } = useTranslation();

  const getDocument = () => {
    if (documentType === 'CI') getDocumentShouldFetchForCI(true);
    else getDocumentShouldFetch(true);
  };

  const openInNewTab = (url: string) => {
    console.log('openInNewTab', url);
    setTimeout(() => {
      window.open(url, '_blank');
    });
  };

  const { shouldFetch: getDocumentShouldFetch } = useGetDocument(
    { key: 'getDocument', filePath, isSettlement },
    token ?? '',
    filePath,
    isSettlement,
    {
      onSuccess: (data: GetDocumentResponse) => {
        openInNewTab(data.presignedUrl);
        getDocumentShouldFetch(false);
      },
      onError: (err) => {
        if (err.message.includes('File not found')) {
          message[MessageType.ERROR](t('common.error.fileNotFound'));
        } else {
          message[MessageType.ERROR](t('common.error.generic'));
        }
        getDocumentShouldFetch(false);
      },
    },
  );
  const { shouldFetch: getDocumentShouldFetchForCI } = useGetDocumentForCI(
    { key: 'useGetDocumentForCI', filePath },
    token ?? '',
    filePath,
    {
      onSuccess: (data: GetDocumentResponse) => {
        openInNewTab(data.presignedUrl);
        getDocumentShouldFetch(false);
      },
      onError: (err) => {
        if (err.message.includes('File not found')) {
          message[MessageType.ERROR](t('common.error.fileNotFound'));
        } else {
          message[MessageType.ERROR](t('common.error.generic'));
        }
        getDocumentShouldFetch(false);
      },
    },
  );
  return (
    <LinkText data-testid="mock-LinkText" onClick={() => getDocument()}>
      {getFilename(filePath)}
    </LinkText>
  );
};
